import CartWinterHolidayModalView from './cartWinterHolidayModal.component.html';

class CartWinterHolidayModalController {
    constructor($scope) {
        'ngInject';

        this.$scope = $scope;
    }

    accept() {
        this.$scope.$parent.$ctrl.close();
    }
}

let cartWinterHolidayModalComponent = {
    bindings: {},
    template: CartWinterHolidayModalView,
    controller: CartWinterHolidayModalController
};

export default cartWinterHolidayModalComponent;
